import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import showIf from 'lib/show-if'
import css from './slide.scss'
import { SectionHeading } from 'components/headings'

export default class Slide extends PureComponent {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }

  render() {
    const { title, children } = this.props

    return (
      <div className={css.slide}>
        {showIf(title, <Title>{title}</Title>)}
        {children}
      </div>
    )
  }
}

export const Title = ({ className, children }) => (
  <SectionHeading className={classNames(css.title, className)}>
    {children}
  </SectionHeading>
)
